import React from "react";

export default function MuteText({ children }) {
  return <div style={{ opacity: 0.5 }}>{children}</div>;
}
